import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import template from './heyeConfig.tpl.html';

interface HEYEConfigScope extends ConfigScope {
  serialConverters: apsViewModels.EquipmentDetail[];
}

export default angular.module('aps.controller.heyeConfig', [])
  .directive('apsHeyeConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: HEYEConfigScope) => {
        scope.serialConverters = scope.vm.allEquipment
          .filter(e => e.type === apsEnums.EquipmentType.SerialConverter);
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/heyeConfig.directive.ts